import React, { useEffect, useState } from "react";

const SRC_DOC = `<!doctype html>
<html lang="fr"><head><meta charset="utf-8" />
<meta name="viewport" content="width=device-width, initial-scale=1" />
<style>
html,body{margin:0;padding:0;background:transparent;font-family:system-ui,sans-serif;overflow:hidden}
select,option,input,#ecuCalculateTool select,#ecuCalculateTool option{color:#000 !important;opacity:1 !important}
</style>
</head><body>
<div id="ecuCalculateTool"></div>
<script>
window.$ecu = {lang:"fr",width:"800",BackgroundColor:"#972525",BoxColor:"#ffffff",FontColor:"#000000",ButtonColor:"#e43c73",ButtonFontColor:"#000000",APIID:"119"};
(function(){var d=document,s=d.createElement("script");s.src="https://xremover.net/calculator/ecuob.js?_="+new Date();s.async=1;d.body.parentNode.insertBefore(s,d.body.nextSibling);})();
var last=0;
setInterval(function(){
  var el=document.getElementById("ecuCalculateTool");
  var h=Math.max(el?el.scrollHeight:0, document.body.scrollHeight);
  if(h && Math.abs(h-last)>8){last=h;parent.postMessage({ecuHeight:h},"*");}
},500);
<\/script>
</body></html>`;

const EcuCalculator = ({ showTitle = true }) => {
  const [height, setHeight] = useState(360);

  useEffect(() => {
    const onMsg = (e) => {
      const h = e.data && e.data.ecuHeight;
      if (typeof h === "number" && h > 100) setHeight(h + 24);
    };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  return (
    <section className="bg-black" data-testid="home-gain-simulator">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-14 md:py-20">
        {showTitle && (
          <>
            <div className="overline mb-3">Performance</div>
            <h2 className="text-4xl sm:text-5xl leading-[0.9] text-white">Simulation de gain</h2>
            <div className="mt-4 h-[3px] w-24 bg-sared" />
          </>
        )}
        <p className="max-w-2xl text-sm md:text-base text-zinc-300">
          Sélectionnez votre véhicule pour estimer le gain de puissance et de couple après reprogrammation.
          Les valeurs sont indicatives et confirmées après lecture de votre calculateur.
        </p>
        <div className="mt-10 max-w-[800px]">
          <iframe
            title="Simulation de gain SHRAL'AUTO"
            data-testid="ecu-calculator-frame"
            srcDoc={SRC_DOC}
            sandbox="allow-scripts allow-forms allow-popups allow-same-origin"
            scrolling="no"
            style={{ height: `${height}px` }}
            className="w-full border-0 block"
          />
        </div>
      </div>
    </section>
  );
};

export default EcuCalculator;
